import React, { Component } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
const firebase = require("firebase");
const PieChart = require("react-chartjs").Pie;
require("firebase/firestore");

const db = firebase.firestore();

class Content extends Component {
  static propTypes = {
    audiences: PropTypes.array
  };

  constructor() {
    super();
    this.state = {
      page: "main",
      options: "1"
    };
  }

  getContent() {
    switch (this.state.page) {
      case "main":
        const loaded = isLoaded(this.props.audiences);
        return (
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">Photo</th>
                <th scope="col">Name</th>
                <th scope="col">Question 1</th>
                <th scope="col">Question 2</th>
              </tr>
            </thead>
            <tbody>
              {loaded ? (
                this.props.audiences.map(audience => (
                  <tr>
                    <td>
                      <img
                        src={audience.photo}
                        width="50px"
                        style={{ borderRadius: "50%" }}
                      />
                    </td>
                    <td>{audience.name}</td>
                    <td>{audience.q1}</td>
                    <td>{audience.q2}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No Available Audience</td>
                </tr>
              )}
            </tbody>
          </table>
        );
      case "poll":
        return (
          <div>
            <h2>Create a Poll</h2>

            <form>
              <fieldset>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    Options
                  </label>
                  <div className="col-sm-10">
                    <select
                      className="form-control"
                      id="exampleSelect1"
                      value={this.state.options}
                      onChange={e => {
                        this.setState({ options: e.target.value });
                      }}
                    >
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="staticEmail"
                    className="col-sm-2 col-form-label"
                  >
                    &nbsp;
                  </label>
                  <div className="col-sm-4">
                    <button
                      type="button"
                      className="btn btn-secondary btn-lg btn-block"
                      onClick={() => {
                        db
                          .collection("poll")
                          .add({
                            options: this.state.options
                          })
                          .then(() => {
                            this.setState({ page: "main" });
                          })
                          .catch(e => {
                            console.log("error", e);
                          });
                      }}
                    >
                      Create
                    </button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        );
      case "pollResult": {
        const loaded = isLoaded(this.props.pollAnswers);
        const result = {};
        if (!loaded) {
          return <div>Loading please wait ...</div>;
        }

        this.props.pollAnswers.forEach(pollAnswer => {
          const ans = pollAnswer.answer;
          result[ans] = result[ans] ? result[ans] + 1 : 1;
        });

        return (
          <PieChart
            options={{ responsive: true }}
            data={Object.keys(result).map(key => ({
              value: result[key],
              label: `Total ${key}`
            }))}
          />
        );
      }
      default:
        return null;
    }
  }

  render() {
    return (
      <div className="container app-content">
        <div className="row">
          <div className="col-md-12">
            <h1>DevC Bandung Meet-up #9</h1>
            <p className="lead">
              How to supercharge your GraphQL Server and Introduction to Fresco
              Library
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-9">{this.getContent()}</div>
          <div className="col-md-3">
            <button type="button" className="btn btn-success btn-lg btn-block">
              Start Networking
            </button>
            <button
              type="button"
              className="btn btn-secondary btn-lg btn-block"
              onClick={() => {
                this.setState({ page: "main" });
              }}
            >
              Atendance List
            </button>
            <button
              type="button"
              className="btn btn-secondary btn-lg btn-block"
              onClick={() => {
                this.setState({ page: "poll" });
              }}
            >
              Begin Poll
            </button>
            <button
              type="button"
              className="btn btn-secondary btn-lg btn-block"
              onClick={() => {
                this.setState({ page: "pollResult" });
              }}
            >
              Poll Result
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  firestoreConnect([
    {
      collection: "audiences",
      orderBy: ["created", "desc"]
    },
    {
      collection: "pollAnswers"
    }
  ]),
  connect((state, props) => ({
    audiences: state.firestore.ordered.audiences,
    pollAnswers: state.firestore.ordered.pollAnswers
  }))
)(Content);



// WEBPACK FOOTER //
// ./src/components/Content.js